import { BASE_URL_API } from 'constants/base-url-default'
import { getCookie, removeCookie } from 'utils/functions-cookie'

export interface Address {
  street_name: string
  street_number: string
  neighborhood: string
  city: string
  state: string
  complement: string
}

export enum SharedTypes {
  FIXED = 'fixed',
  PERCENT = 'percent',
}

export interface Company {
  id: string
  name: string
  trading_name: string
  cnpj: string
  logo_url: string
  default_share_value: number
  share_type: SharedTypes
  address: Address
}

export interface Root {
  id: string
  name: string
  email: string
  company: Company
  detail?: string
}

export const getProfile = async () => {
  const authToken = getCookie('auth_token')

  if (!authToken) {
    throw new Error('Você não está autenticado.')
  }

  const response = await fetch(`${BASE_URL_API}/me`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
  })

  const { detail, ...userData } = (await response.json()) as Root

  if (response.status === 403) {
    removeCookie('auth_token')
    window.location.reload()
  }

  if (response.status !== 200) {
    throw new Error(detail)
  }

  return userData
}
